!(function () {
  const addSwiperClasses = (el) => {
    const wrapper = el.querySelector(".multicolumn-list__wrapper"),
      slides = el.querySelectorAll(".multicolumn-list__item");
    el.classList.add("swiper");
    wrapper && wrapper.classList.add("swiper-wrapper");
    slides.forEach((el) => el.classList.add("swiper-slide"));
  };

  const removeSwiperClasses = (el) => {
    const wrapper = el.querySelector(".multicolumn-list__wrapper"),
      slides = el.querySelectorAll(".multicolumn-list__item");
    el.classList.remove("swiper");
    wrapper && wrapper.classList.remove("swiper-wrapper");
    slides.forEach((el) => {
      el.removeAttribute("style");
      el.classList.remove("swiper-slide");
    });
  };

  const initSwiper = (section) => {
    const el = section.querySelector(".swiper--multicolumn:not(.swiper-initialized)");
    if (!el) return;

    addSwiperClasses(el);

    const mobile  = Number(el.dataset.mobileColumns)  || 1;
    const desktop = Number(el.dataset.desktopColumns) || 1;
    const mid     = desktop === 4 ? desktop - 1 : desktop;
    const lower   = desktop > 2 ? mid - 1 : desktop;

    // 🔎 Buttons & Pagination finden (liegen als Geschwister in .multicolumn-list)
    const list     = el.closest('.multicolumn-list') || el;
    const prevBtn  = list.querySelector('.multicolumn__nav--prev');
    const nextBtn  = list.querySelector('.multicolumn__nav--next');
    const pagEl    = list.querySelector('.multicolumn__pagination');

    const config = {
      loop: false,
      speed: 800,
      slidesPerView: mobile,
      slidesPerGroup: mobile,
      freeMode: true,
      direction: 'horizontal',
      touchStartPreventDefault: false,
      touchMoveStopPropagation: false,
      touchAngle: 20,
      spaceBetween: 8,
      breakpoints: {
        750:  { slidesPerView: lower,  slidesPerGroup: lower,  spaceBetween: 24 },
        990:  { slidesPerView: mid,    slidesPerGroup: mid,    spaceBetween: 24 },
        1360: { slidesPerView: desktop,slidesPerGroup: desktop,spaceBetween: 24 },
      },
      pagination: {
        el: pagEl,
        clickable: false,
        type: "custom",
        renderCustom: function (swiper, current, total) {
          let html = "";
          for (let i = 1; i <= total; i++) {
            html += i === current
              ? `<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`
              : `<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
          }
          return html;
        },
      },
      // 🔑 Keyboard-Navigation
      keyboard: { enabled: true, onlyInViewport: true }
    };

    // ⬅️➡️ Chevron-Buttons an Swiper hängen (falls vorhanden)
    if (prevBtn && nextBtn) {
      config.navigation = { prevEl: prevBtn, nextEl: nextBtn };
    }

    const swiper = new Swiper(el, config);

    // 🧠 Trackpad/Horizontales Scrollen (deine bestehende Logik bleibt)
    el.addEventListener(
      'wheel',
      (event) => {
        const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (isHorizontalScroll && Math.abs(event.deltaX) > 1) {
          event.preventDefault();

          const current = swiper.getTranslate();
          const target  = current - event.deltaX;

          const max = swiper.maxTranslate();
          const min = swiper.minTranslate();
          const clamped = Math.max(Math.min(target, min), max);

          swiper.setTranslate(clamped);
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
          swiper.pagination.render();
          updateNav(); // ← Buttons Zustand nach Scroll aktualisieren
        }
      },
      { passive: false }
    );

    // 🔒 Buttons ein-/ausblenden & disabled setzen
    function updateNav() {
      if (!(prevBtn && nextBtn)) return;
      const locked = swiper.isLocked || (swiper.slides && swiper.slides.length <= swiper.params.slidesPerView);
      // Anzeigen/Verstecken wenn nicht nötig
      prevBtn.style.display = locked ? 'none' : 'grid';
      nextBtn.style.display = locked ? 'none' : 'grid';
      // Disabled-State
      // In freeMode nutzen wir Progress als robuste Heuristik
      const atStart = swiper.progress <= 0.001;
      const atEnd   = swiper.progress >= 0.999;
      prevBtn.disabled = locked || atStart;
      nextBtn.disabled = locked || atEnd;
      prevBtn.setAttribute('aria-disabled', String(prevBtn.disabled));
      nextBtn.setAttribute('aria-disabled', String(nextBtn.disabled));
    }

    // Events, die den Button-Status aktualisieren sollen
    swiper.on('afterInit', updateNav);
    swiper.on('slideChange', updateNav);
    swiper.on('setTranslate', updateNav);
    swiper.on('resize', updateNav);
    swiper.on('lock', updateNav);
    swiper.on('unlock', updateNav);
    swiper.on('progress', updateNav);
    updateNav();
  };

  const destroySwiper = (section) => {
    const el = section.querySelector(".swiper--multicolumn");
    if (el && el.swiper) {
      el.swiper.destroy();
      removeSwiperClasses(el);
    }
  };

  const observeSection = (section) => {
    if (!section || !section.classList.contains("multicolumn-section")) return;

    const swiperEl = section.querySelector(".swiper--multicolumn");
    if (!swiperEl) return;

    new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const width = entry.contentRect.width;
        const mobileEnabled  = swiperEl.dataset.sliderMobile  === "true";
        const desktopEnabled = swiperEl.dataset.sliderDesktop === "true";

        if ((width < 576 && mobileEnabled) || (width >= 576 && desktopEnabled)) {
          initSwiper(entry.target);
        } else {
          destroySwiper(entry.target);
        }
      });
    }).observe(section);
  };

  // Initial call
  observeSection(document.currentScript.parentElement);

  // Re-init on section reload (Shopify)
  document.addEventListener("shopify:section:load", (e) => {
    observeSection(e.target);
  });
})();
